import React from 'react';
import { useTranslation } from 'react-i18next';
import Aux from '../../hoc/Aux';

const ProjectSolutionCalculationInactive = (props) => {

  const { t } = useTranslation();

    if (props.calculator === undefined) {
      return null
    } else {

    const area_unit = "mm²";

    const numberWithCommas = (x) => {
      if (x !== undefined) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        return "";
      }
    }

    const displayArea = (x) => numberWithCommas(x).toString() + " " + area_unit.toString()

    return (

      <div className="container">
        <div className="row">
          <div className="col-sm">

          { (props.calculator.hole_form === "square") && (
            <Aux>
            <table>
              <tr>
                <td>{ t('product_solution.calculation_result.langtext.form_des_durchbruchs_label.long') }</td>
                <td colSpan={3} style={{textAlign: "right"}}>{ t('product_solution.calculation_result.langtext.form_des_durchbruchs_eckig') }</td>
              </tr>
              <tr>
                <td>{ t('product_solution.calculation_result.langtext.flaeche_des_durchbruchs.long', { height: props.calculator.hole_height,
                                                                                               width: props.calculator.hole_width} )}</td>
                <td></td>
                <td style={{padding: "0px 10px"}}> = </td>
                <td style={{textAlign: "right", whiteSpace: "nowrap", maxWidth: "120px"}}>{ displayArea(props.resSchottbelegung.possible_area) }</td>
              </tr>
            </table>
            <button style={{margin: "20px 0px"}} className="btn btn-primary" onClick={()=> props.showCalculatorForm()}>{ t('product_solution.calculation_result.langtext.button_schottgroesse_aendern') }</button>
            </Aux>
          )}

          { (props.calculator.hole_form === "circle") && (
            <Aux>
            <table>
              <tr>
                <td>{ t('product_solution.calculation_result.langtext.form_des_durchbruchs_label.long') }</td>
                <td colSpan={3} style={{textAlign: "right"}}>{ t('product_solution.calculation_result.langtext.form_des_durchbruchs_rund') }</td>
              </tr>
              <tr>
                <td>{ t('product_solution.calculation_result.langtext.flaeche_des_durchbruchs_rund.long', { diameter: props.calculator.hole_diameter} )}</td>
                <td></td>
                <td style={{padding: "0px 10px"}}> = </td>
                <td style={{textAlign: "right", whiteSpace: "nowrap", maxWidth: "120px"}}>{ displayArea(props.resSchottbelegung.possible_area) }</td>
              </tr>
            </table>
            <button style={{margin: "20px 0px"}} className="btn btn-primary" onClick={()=> props.showCalculatorForm()}>{ t('product_solution.calculation_result.langtext.button_schottgroesse_aendern') }</button>
            </Aux>
          )}

          { (props.calculator.hole_form !== "circle") && (props.calculator.hole_form !== "square") && (
            <span>
              <div>
              { t('product_solution.calculation_result.noch_keine_dimensionen_eingegeben_hinweis') }<br /><br />
              </div>
              <button className="btn btn-primary" onClick={()=> props.showCalculatorForm()}>{ t('product_solution.calculation_result.langtext.button_schottgroesse_festlegen') }</button>
            </span>
          )}

          </div>
          <div className="col-sm">


          </div>
        </div>
      </div>

    )
  }
}



export default ProjectSolutionCalculationInactive



// WEBPACK FOOTER //
// ./src/components/Modals/ProjectSolutionCalculationInactive.js